module.exports = __webpack_public_path__ + "static/media/pohon2.a7a2a4da.png";